// removed by extract-text-webpack-plugin
module.exports = {"loader-container":"_2G9Ry7uLWE8xGyg0Ueyndc","loader-container-hide":"tA5YPUtZNmil60cxgSm0e _2G9Ry7uLWE8xGyg0Ueyndc","spinner":"_1FNksn-DOC2GvjPqw1ilJA","double-bounce1":"DA2lM5bvfdkZyFAb775Wh","double-bounce2":"r52LMBdnmQ_U7l8cHHUBu","sk-bounce":"rwmePSrXcc34kCiu_58VF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/Loader.scss
// module id = 419
// module chunks = 47